function getProductForm(button) {
  if (button.form) {
    return button.form;
  }

  const buyButtons = button.closest('buy-buttons');
  const formId = button.getAttribute('form') || buyButtons?.getAttribute('form');

  return formId ? document.getElementById(formId) : button.closest('form');
}

function getGiftCheckboxes(form) {
  const productContainer = form.closest('product-rerender');
  const selector = '.gift-checkbox:checked';

  return Array.from((productContainer || document).querySelectorAll(selector));
}

function buildCartFormData(form) {
  const originalFormData = new FormData(form);
  const variantInput = form.querySelector('[name="id"]');
  const variantId = originalFormData.get('id') || variantInput?.value;

  // Some mobile browsers can leave the initially disabled variant input disabled.
  // Always include the selected variant explicitly before calling the Cart API.
  if (variantId && !originalFormData.has('id')) {
    originalFormData.set('id', variantId);
  }

  const giftCheckboxes = getGiftCheckboxes(form);
  if (giftCheckboxes.length === 0 || !variantId) {
    return { formData: originalFormData, variantId: String(variantId || '') };
  }

  // Shopify's multi-item API must not mix a top-level `id` with `items[...]`.
  const formData = new FormData();
  formData.append('items[0][id]', variantId);
  formData.append('items[0][quantity]', originalFormData.get('quantity') || '1');

  const sellingPlan = originalFormData.get('selling_plan');
  if (sellingPlan) {
    formData.append('items[0][selling_plan]', sellingPlan);
  }

  for (const [key, value] of originalFormData.entries()) {
    const propertyMatch = key.match(/^properties\[(.+)\]$/);
    if (propertyMatch) {
      formData.append(`items[0][properties][${propertyMatch[1]}]`, value);
    }
  }

  giftCheckboxes.forEach((checkbox, index) => {
    const itemIndex = index + 1;
    formData.append(`items[${itemIndex}][id]`, checkbox.value);
    formData.append(`items[${itemIndex}][quantity]`, '1');
  });

  return { formData, variantId: String(variantId) };
}

async function addProductAndCheckout(button) {
  const form = getProductForm(button);
  if (!form) {
    throw new Error('Product form not found.');
  }

  if (!form.checkValidity()) {
    form.reportValidity();
    return;
  }

  const { formData, variantId } = buildCartFormData(form);
  if (!variantId) {
    throw new Error('Selected variant not found.');
  }

  const shopRoot = window.Shopify?.routes?.root || '/';
  const routeRoot = shopRoot.endsWith('/') ? shopRoot : `${shopRoot}/`;

  button.setAttribute('aria-busy', 'true');
  button.disabled = true;

  try {
    const addResponse = await fetch(`${routeRoot}cart/add.js`, {
      method: 'POST',
      body: formData,
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    });
    const addResult = await addResponse.json().catch(() => ({}));

    if (!addResponse.ok) {
      throw new Error(addResult.description || 'Failed to add product to cart.');
    }

    // Confirm that this browser session can see the newly added variant before
    // navigating. This prevents an empty cart from being sent to /checkout.
    const cartResponse = await fetch(`${routeRoot}cart.js`, {
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    });
    const cart = await cartResponse.json();
    const productWasAdded = cartResponse.ok && cart.items?.some(
      (item) => String(item.variant_id) === variantId
    );

    if (!productWasAdded) {
      throw new Error('The selected product was not found in the cart after adding it.');
    }

    window.location.assign(`${routeRoot}checkout`);
  } finally {
    button.disabled = false;
    button.removeAttribute('aria-busy');
  }
}

document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-buy-now]');
  if (!button || button.disabled) {
    return;
  }

  event.preventDefault();

  event.stopImmediatePropagation();

  try {
    await addProductAndCheckout(button);
  } catch (error) {
    console.error('Error while adding Buy Now product:', error);
    alert(error.message || 'Something went wrong. Please try again.');
  }
}, true);
